import { render, staticRenderFns } from "./SetProjectOwnership.vue?vue&type=template&id=52bda878&"
import script from "./SetProjectOwnership.vue?vue&type=script&lang=ts&"
export * from "./SetProjectOwnership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
